import { render } from "./Compare.vue?vue&type=template&id=2a2796fc&scoped=true"
import script from "./compare.js?vue&type=script&lang=js&external"
export * from "./compare.js?vue&type=script&lang=js&external"

import "./Compare.vue?vue&type=style&index=0&id=2a2796fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2796fc"]])

export default __exports__